/**
 * Limite maximo de pestañas abiertas simultaneamente por modulo (sin contar la pestaña base).
 * Parametrizado para poder ajustarlo en un solo lugar. Por ahora 8.
 */
export const MAX_OPEN_TABS = 8;

export const PROFILE_MENU_ITEMS = [
  { id: 2, action: 'NAV.PROFILE' },
  { id: 3, action: 'ENUM.EventType.LOGOUT' },
];
